import { CButton } from '@coreui/react'
import React from 'react'
import { IoArrowBackCircleSharp } from 'react-icons/io5'

const ContentHeader = (props) => {
    return (
        <div className={"ContHead_KBqYrE paddingLeft-0 paddingRight-0"} >
            <h4 className={"ContHead_TitleN_pjnmZq marginLeft-10 todayTask_MNhq_74tI"} >{props.name}</h4>

            {props.withBackbtn && 
          
            <CButton onClick={() => props.withBackbtn()}>
              <IoArrowBackCircleSharp size={"3rem"} color={"#1f4671"} />
            </CButton>
        
            }
        </div>
    )
}

export default ContentHeader
